import {
  GET_YOUTUBE_SHORT_VIDEOS,
  GET_YOUTUBE_SHORT_VIDEOS_SUCCESS,
  GET_YOUTUBE_SHORT_VIDEOS_FAIL,
  GET_YOUTUBE_SHORT_VIDEO_DETAILS,
  GET_YOUTUBE_SHORT_VIDEO_DETAILS_SUCCESS,
  GET_YOUTUBE_SHORT_VIDEO_DETAILS_FAIL,
  CREATE_YOUTUBE_SHORT_VIDEO,
  CREATE_YOUTUBE_SHORT_VIDEO_SUCCESS,
  CREATE_YOUTUBE_SHORT_VIDEO_FAIL,
  UPDATE_YOUTUBE_SHORT_VIDEO,
  UPDATE_YOUTUBE_SHORT_VIDEO_SUCCESS,
  UPDATE_YOUTUBE_SHORT_VIDEO_FAIL,
  DELETE_YOUTUBE_SHORT_VIDEO_SUCCESS,
  DELETE_YOUTUBE_SHORT_VIDEO_FAIL,
  DELETE_YOUTUBE_SHORT_VIDEO,

} from "./actionTypes"

// YoutubeShortVideo - This line cannot be edited or removed
export const getYoutubeShortVideos = (
  page,
  limit,
  searchText,
  youtubeShortVideoId,

) => ({
  type: GET_YOUTUBE_SHORT_VIDEOS,
  payload: { page, limit, searchText, youtubeShortVideoId,  },
})

export const getYoutubeShortVideosSuccess = youtubeShortVideos => ({
  type: GET_YOUTUBE_SHORT_VIDEOS_SUCCESS,
  payload: youtubeShortVideos,
})

export const getYoutubeShortVideosFail = error => ({
  type: GET_YOUTUBE_SHORT_VIDEOS_FAIL,
  payload: error,
})

export const getYoutubeShortVideoDetails = youtubeShortVideoId => ({
  type: GET_YOUTUBE_SHORT_VIDEO_DETAILS,
  payload: youtubeShortVideoId,
})

export const getYoutubeShortVideoDetailsSuccess = youtubeShortVideoDetails => ({
  type: GET_YOUTUBE_SHORT_VIDEO_DETAILS_SUCCESS,
  payload: youtubeShortVideoDetails,
})

export const getYoutubeShortVideoDetailsFail = error => ({
  type: GET_YOUTUBE_SHORT_VIDEO_DETAILS_FAIL,
  payload: error,
})

export const createYoutubeShortVideo = (youtubeShortVideo, onCloseClick) => ({
  type: CREATE_YOUTUBE_SHORT_VIDEO,
  payload: { youtubeShortVideo, onCloseClick },
})

export const createYoutubeShortVideoSuccess = youtubeShortVideo => ({
  type: CREATE_YOUTUBE_SHORT_VIDEO_SUCCESS,
  payload: youtubeShortVideo,
})

export const createYoutubeShortVideoFail = error => ({
  type: CREATE_YOUTUBE_SHORT_VIDEO_FAIL,
  payload: error,
})

export const getYoutubeShortVideoDetail = youtubeShortVideoId => ({
  type: GET_YOUTUBE_SHORT_VIDEO_DETAILS,
  payload: youtubeShortVideoId,
})

export const updateYoutubeShortVideo = (youtubeShortVideo, youtubeShortVideoId, onCloseClick) => ({
  type: UPDATE_YOUTUBE_SHORT_VIDEO,
  payload: { youtubeShortVideo, youtubeShortVideoId, onCloseClick },
})

export const updateYoutubeShortVideoSuccess = youtubeShortVideo => ({
  type: UPDATE_YOUTUBE_SHORT_VIDEO_SUCCESS,
  payload: youtubeShortVideo,
})

export const updateYoutubeShortVideoFail = error => ({
  type: UPDATE_YOUTUBE_SHORT_VIDEO_FAIL,
  payload: error,
})

export const deleteYoutubeShortVideo = youtubeShortVideoId => ({
  type: DELETE_YOUTUBE_SHORT_VIDEO,
  payload: { youtubeShortVideoId },
})

export const deleteYoutubeShortVideoSuccess = youtubeShortVideo => ({
  type: DELETE_YOUTUBE_SHORT_VIDEO_SUCCESS,
  payload: youtubeShortVideo,
})

export const deleteYoutubeShortVideoFail = error => ({
  type: DELETE_YOUTUBE_SHORT_VIDEO_FAIL,
  payload: error,
})
